import { createApiRequest } from "@/lib/api/createApiService";
import { USER_MANAGEMENT_ENDPOINTS } from "./user-management.endpoints";

export const userService = {
  listUsers: async (params = {}, options = {}) => {
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getUser: async (userId, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.DETAIL(userId),
      method: "GET",
      ...options,
    });
  },

  createUser: async (payload, options = {}) => {
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateUser: async (userId, payload, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.UPDATE(userId),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  unlockUser: async (userId, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.UNLOCK(userId),
      method: "PATCH",
      body: {},
      ...options,
    });
  },

  markUserDeleted: async (userId, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.UPDATE(userId),
      method: "PATCH",
      body: { status: "deleted" },
      ...options,
    });
  },

  assignFollowUp: async (userId, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.FOLLOW_UP(userId),
      method: "PATCH",
      body: {},
      ...options,
    });
  },

  revokeFollowUp: async (userId, options = {}) => {
    if (!userId) throw new Error("userId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.UNFOLLOW_UP(userId),
      method: "PATCH",
      body: {},
      ...options,
    });
  },

  checkCanCreateUser: async (companyId, options = {}) => {
    if (!companyId) throw new Error("companyId is required");
    return createApiRequest({
      url: USER_MANAGEMENT_ENDPOINTS.CHECK_CAN_CREATE,
      method: "GET",
      body: { companyId },
      ...options,
    });
  },
};
